/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {DeslocamentoListComponent} from "./deslocamento-list/deslocamento-list.component";
import {DeslocamentoFormComponent} from "./deslocamento-form/deslocamento-form.component";
import {editRoute, newRoute, detailRoute} from "../../shared/services/data.service";
import {DelocamentoDetailComponent} from "./delocamento-detail/delocamento-detail.component";
import {DeslocamentoHistoryComponent} from "./deslocamento-history/deslocamento-history.component";
import {DeslocamentoCalendarComponent} from "./deslocamento-calendar/deslocamento-calendar.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class DeslocamentosRoutingModule {}

export const deslocamentosRoutes: any[] = [
    {
        path: '',
        component: DeslocamentoListComponent
    },{
        path: editRoute + '/:id',
        component: DeslocamentoFormComponent
    },{
        path: newRoute,
        component: DeslocamentoFormComponent
    },{
        path: detailRoute + '/:id',
        component: DelocamentoDetailComponent
    },{
        path: 'historico',
        component: DeslocamentoHistoryComponent
    },{
        path: 'agenda',
        component: DeslocamentoCalendarComponent
    }
];

export const deslocamentosVisitanteRoutes: any[] = [
    {
        path: '',
        component: DeslocamentoListComponent
    },{
        path: editRoute + '/:id',
        component: DeslocamentoFormComponent
    },{
        path: newRoute,
        component: DeslocamentoFormComponent
    },{
        path: detailRoute + '/:id',
        component: DelocamentoDetailComponent
    },
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/deslocamentos/deslocamentos-routing.module.ts
 **/